import { render, staticRenderFns } from "./JobsCountPerDurationCard.vue?vue&type=template&id=30120da2&"
import script from "./JobsCountPerDurationCard.vue?vue&type=script&lang=js&"
export * from "./JobsCountPerDurationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports